import { Post, Get, Put, Delete } from '@/utils/request';

export default {
    login: (params) => {
        // return Post('/GeotextilesLayingVessel/UserServlet', params);
        return Post('/GeotextilesLayingVessel/UserServlet', params);
    },
    menuList: (params) => {
        return Post('/GeotextilesLayingVessel/ControlTypeServlet', params);
    },
}